import getUserFullName from './get-user-full-name'

const utilities = {
    getUserFullName
}

export default utilities
